import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';

class CourseListing extends Component {

  render() {
    const courseIconUrl = 'https://my.kabbalah.com/ticket-widget/media/course-icon.png';
    const { store, courseId } = this.props;  
    const course = store.courses[courseId];
    return (
      <li className="list-group-item">
        <Link to={'/courses/' + courseId }>
          <div className="container text-dark">
            <div className="row align-items-center">
              <div className="col-lg-1 d-none d-lg-block text-center">
                <img width="50px" src={courseIconUrl} alt="" />
              </div>
              <div className="col-10 col-lg-8">
                <p>{course.Name}              
                </p>            
              </div>
              <div className="col-2 d-block d-lg-none text-right align-self-start">
                <img width="50px" src={courseIconUrl} alt="" />
              </div>            
              <div className="col-12 col-lg-3 text-lg-center">
                <p>
                  <span className="d-inline d-lg-none font-weight-light">Start Date:&nbsp;</span>
                  {course.CloseDate}                
                </p>
              </div>
            </div>
          </div>
        </Link>
      </li>
    );
  }

}

export default inject('store')(observer(CourseListing));



// WEBPACK FOOTER //
// ./src/components/CourseListing.js